module.exports = __webpack_public_path__ + "static/media/dth_2.c18632b9.svg";